import { notifications } from '@mantine/notifications'
import { Font, pdf, StyleSheet } from '@react-pdf/renderer'

export const generatePdf = async (
  document: JSX.Element,
  onCreate: (e: boolean) => void,
) => {
  try {
    const blob = await pdf(document).toBlob()

    const url = URL.createObjectURL(blob)

    window.open(url, '_blank')
    onCreate(false)
  } catch (e) {
    notifications.show({
      color: 'red',
      message: `Couldn't export statistics to PDF file.`,
      title: 'PDF export error',
    })
    onCreate(false)
  }
}

Font.register({
  family: 'Montserrat',
  fonts: [
    {
      fontWeight: 'normal',
      src: '/fonts/Montserrat-Regular.ttf',
    },
    {
      fontWeight: 'semibold',
      src: '/fonts/Montserrat-SemiBold.ttf',
    },
  ],
})

export const styles = StyleSheet.create({
  container: {
    gap: 20,
  },
  logo: {
    margin: '0 auto',
    marginBottom: '50px',
  },
  page: {
    backgroundColor: '#F4F4F4',
    padding: '28px 40px',
  },
  text: {
    fontFamily: 'Montserrat',
    fontSize: 24,
    fontWeight: 'semibold',
    marginBottom: '32px',
    textAlign: 'center',
  },
})
